import {
  faBitbucket,
  faGithub,
  faGitlab,
  faJenkins,
  IconDefinition,
} from "@fortawesome/free-brands-svg-icons";

import { CIProvider } from "../types";

import AzureIcon from "@assets/inventory-icons/AzureIcon.png";
import BuildkiteIcon from "@assets/inventory-icons/BuildkiteIcon.png";
import CircleCIIcon from "@assets/inventory-icons/CircleCIIcon.png";

interface SetupCIInfo {
  iconFa?: IconDefinition;
  iconSrc?: string;
  title: string;
  valueProps: string[];
}

export const SETUP_CI_INFO_BY_PROVIDER: { [key in CIProvider]: SetupCIInfo } = {
  github: {
    iconFa: faGithub,
    title: "GitHub Actions",
    valueProps: ["automate scans", "upload findings"],
  },
  gitlab: {
    iconFa: faGitlab,
    title: "GitLab CI/CD",
    valueProps: [
      "automate scans",
      "upload findings",
      "show MR comments to developers",
    ],
  },
  jenkins: {
    iconFa: faJenkins,
    title: "Jenkins pipeline",
    valueProps: ["automate scans", "upload findings"],
  },
  bitbucket: {
    iconFa: faBitbucket,
    title: "Bitbucket pipeline",
    valueProps: ["automate scans", "upload findings"],
  },
  circleci: {
    iconSrc: CircleCIIcon,
    title: "CircleCI pipeline",
    valueProps: ["automate scans", "upload findings"],
  },
  buildkite: {
    iconSrc: BuildkiteIcon,
    title: "Buildkite pipeline",
    valueProps: ["automate scans", "upload findings"],
  },
  azure: {
    iconSrc: AzureIcon,
    title: "Azure pipeline",
    valueProps: ["automate scans", "upload findings"],
  },
};
